import * as financeAPI from "@/api/accountFinance.api"
import moment from "moment"

export const checkHasFinanceData = async ({ commit }, accountKey) => {
  try {
    const hasFinancialData = await financeAPI.hasData(accountKey)

    commit("setHasFinanceData", hasFinancialData)
  } catch (e) {
    console.log(e)
    commit("setHasFinanceData", false)
  }
}

export const getFinanceData = async ({ commit, dispatch }, { accountKey, from, to }) => {
  try {
    const diffInDays = moment(to).diff(moment(from), "days")
    const frequency = diffInDays >= 31 ? "monthly" : "daily"

    // Neither podcast action rejects — a missing/failing podcast report must not take
    // down the rest of the finance page.
    const [financeData] = await Promise.all([
      financeAPI.getData(accountKey, frequency, { from, to }),
      dispatch("getPodcastRevenue", { accountKey, frequency, from, to }),
      dispatch("getPodcastRevenueByPodcast", { accountKey, frequency, from, to }),
    ])

    commit("setFinancePeriod", { from, to, frequency })
    commit("setFinanceData", financeData)
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const getPodcastRevenue = async ({ commit }, { accountKey, frequency, from, to }) => {
  try {
    const podcastRevenue = await financeAPI.getPodcastRevenue(accountKey, frequency, { from, to })

    // Access is enforced API-side (portal admins only, for now) and the endpoint may not
    // be deployed everywhere yet, so a rejection — or anything that isn't the documented
    // shape — means "report unavailable" rather than an empty chart.
    commit("setPodcastRevenue", Array.isArray(podcastRevenue?.entries) ? podcastRevenue : null)
  } catch (e) {
    console.log(e)
    commit("setPodcastRevenue", null)
  }
}

export const getPodcastRevenueByPodcast = async ({ commit }, { accountKey, frequency, from, to }) => {
  try {
    // aggType has to match the other reports: on "monthly" the API drops an in-progress
    // current month, so omitting it here would leave the per-podcast bars summing to more
    // than the Podcast Ad card and its chart for any range covering today.
    const breakdown = await financeAPI.getPodcastRevenueByPodcast(accountKey, { from, to, aggType: frequency })

    // Same reasoning as getPodcastRevenue: a rejection or an unexpected shape means the
    // breakdown simply isn't available, not that the page is broken.
    commit("setPodcastRevenueByPodcast", Array.isArray(breakdown?.podcasts) ? breakdown : null)
  } catch (e) {
    console.log(e)
    commit("setPodcastRevenueByPodcast", null)
  }
}

export const fetchInvoiceSettings = async ({ commit }, accountKey) => {
  try {
    const invoiceSettings = await financeAPI.getInvoiceSettings(accountKey)

    commit("setInvoiceSettings", invoiceSettings)
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const updateInvoiceSettings = async ({ commit }, data) => {
  try {
    const settings = await financeAPI.updateInvoiceSettings(data)

    commit("setInvoiceSettings", settings)
  } catch (e) {
    console.log(e)
    throw e
  }
}
